import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Western Port Recycled Water Scheme - Stage 1B</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        Stage 1B will extend the recycled water pipeline installation to include Vervale, Catani, Iona, Garfield and Bayles. We expect Stage 1B to start construction in approximately 2027. 
        </p>
        <p className="italic">
        *The proposed pipeline alignment for Stage1B is subject to change.
        </p>
        <p>
          For up-to-date project information, click{' '}
          <a
            href="https://southeastwater.com.au/westernport"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Western Port Recycled Water Scheme - Stage 1B',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800407877 ">1800 407 877</a> |{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: ENGAGEMENT@SEW.COM.AU - Western Port Recycled Water Scheme - Stage 1B',
              });
            }}
          >
            engagement@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
